import { render, staticRenderFns } from "./DocumentButton.vue?vue&type=template&id=551ee220"
import script from "./DocumentButton.vue?vue&type=script&lang=ts"
export * from "./DocumentButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports